import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 761.000000 669.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,669.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3556 6442 c-10 -2 -90 -46 -178 -98 -88 -52 -161 -94 -163 -94 -2 0
-21 -12 -42 -26 -21 -14 -47 -30 -58 -35 -11 -5 -33 -18 -50 -29 -16 -11 -39
-24 -50 -29 -11 -5 -72 -40 -135 -78 -63 -38 -146 -86 -185 -107 -38 -21 -89
-51 -112 -66 -22 -16 -51 -31 -62 -35 -12 -3 -21 -11 -21 -16 0 -5 -5 -9 -11
-9 -5 0 -53 -26 -106 -57 -124 -75 -203 -121 -228 -133 -11 -6 -27 -14 -35
-20 -20 -13 -351 -209 -373 -221 -9 -5 -25 -14 -35 -19 -9 -6 -26 -14 -37 -20
-11 -5 -38 -22 -60 -38 l-40 -28 -3 -512 c-2 -458 -1 -513 14 -519 17 -6 30
-1 114 48 30 18 80 45 110 62 49 27 158 91 200 117 8 5 38 21 65 35 28 14 66
35 85 47 68 41 135 79 165 94 17 8 44 23 60 34 17 11 37 23 45 27 18 8 158 89
180 103 8 6 22 13 30 17 8 4 64 35 123 70 60 35 110 63 112 63 2 0 48 27 103
59 56 33 110 62 121 66 12 3 21 11 21 16 0 5 4 9 10 9 8 0 132 68 200 110 8 5
29 16 45 25 17 8 73 41 125 73 l95 57 3 521 c2 549 3 546 -42 536z"
          />
          <path
            d="M3625 5059 c-4 -5 -17 -15 -28 -20 -12 -5 -35 -18 -52 -29 -16 -11
-39 -24 -50 -29 -11 -5 -58 -32 -105 -60 -47 -27 -107 -62 -134 -76 -27 -14
-69 -39 -93 -55 -24 -17 -47 -30 -50 -30 -3 0 -31 -15 -62 -34 -58 -35 -108
-64 -176 -101 -22 -11 -58 -33 -80 -47 -23 -14 -63 -38 -90 -52 -28 -15 -57
-31 -65 -36 -102 -61 -189 -110 -195 -110 -5 0 -23 -11 -41 -25 -18 -14 -35
-25 -39 -25 -3 0 -56 -29 -116 -65 -60 -36 -112 -65 -114 -65 -3 0 -24 -12
-48 -27 -40 -26 -76 -47 -197 -114 -30 -16 -80 -45 -110 -64 -30 -19 -68 -41
-85 -49 -16 -9 -52 -29 -80 -46 -27 -16 -57 -33 -65 -37 -8 -3 -85 -48 -170
-98 -85 -50 -172 -100 -193 -110 -84 -43 -77 12 -77 -600 0 -299 3 -550 6
-559 8 -20 38 -21 58 -1 8 8 25 20 38 25 13 6 37 19 53 30 17 11 39 24 50 29
11 5 37 21 58 35 21 14 40 26 43 26 4 0 26 14 51 30 24 17 46 30 49 30 3 0 70
39 150 88 79 48 152 92 162 97 45 26 137 82 161 97 14 10 33 21 41 24 15 7
280 165 328 196 15 10 34 21 42 25 12 5 644 378 700 413 92 57 200 120 204
120 3 0 25 14 49 30 25 17 47 30 50 30 4 0 25 13 49 29 44 29 104 65 170 101
72 39 68 8 68 576 0 482 -1 512 -18 527 -21 20 -38 22 -47 6z"
          />
          <path
            d="M5930 4999 c-52 -32 -98 -58 -103 -59 -4 0 -26 -13 -49 -30 -22 -16
-45 -30 -49 -30 -5 0 -42 -20 -82 -45 -41 -25 -78 -45 -82 -45 -4 0 -27 -13
-52 -30 -24 -16 -46 -30 -48 -30 -7 0 -340 -192 -355 -204 -8 -7 -35 -23 -60
-35 -25 -12 -52 -26 -60 -31 -37 -23 -171 -100 -175 -100 -2 0 -24 -13 -48
-30 -25 -16 -49 -30 -54 -30 -5 0 -32 -16 -62 -35 -29 -19 -54 -35 -57 -35 -2
0 -36 -19 -76 -43 -40 -24 -80 -46 -88 -50 -8 -4 -28 -16 -45 -27 -16 -11 -39
-24 -50 -29 -11 -5 -54 -29 -95 -53 -41 -24 -82 -48 -90 -52 -8 -4 -24 -12
-35 -19 -54 -32 -205 -119 -305 -175 -25 -14 -62 -36 -83 -49 -21 -13 -48 -28
-60 -33 -12 -6 -29 -14 -37 -20 -8 -5 -73 -44 -145 -85 -71 -41 -137 -80 -145
-85 -8 -6 -24 -14 -35 -19 -12 -5 -63 -35 -115 -66 -52 -32 -101 -60 -110 -64
-53 -23 -110 -68 -110 -87 0 -22 19 -35 170 -117 30 -16 62 -35 70 -42 12 -9
201 -118 235 -135 5 -3 28 -17 50 -31 22 -14 47 -29 55 -32 8 -4 29 -16 45
-27 17 -11 62 -37 100 -59 39 -22 75 -43 81 -48 26 -20 78 -43 98 -43 18 0
145 67 226 120 8 5 41 23 72 39 32 17 75 41 95 54 21 13 45 27 53 31 8 4 40
21 72 39 72 41 193 109 238 133 19 11 40 25 48 32 7 6 17 12 22 12 5 0 43 20
84 45 42 25 78 45 80 45 2 0 61 34 132 75 71 41 132 75 136 75 5 0 8 -287 8
-638 0 -503 3 -642 13 -656 12 -16 45 -17 462 -16 247 0 453 4 458 9 5 5 13
2683 7 2904 0 32 -52 17 -150 -44z"
          />
          <path
            d="M2510 2984 c-50 -29 -129 -71 -295 -159 -102 -54 -250 -134 -285
-155 -8 -4 -70 -36 -137 -71 -67 -34 -125 -69 -128 -78 -10 -25 -6 -651 4
-669 8 -14 52 -16 443 -19 279 -3 444 0 461 6 l27 11 -2 577 c-3 570 -3 578
-23 580 -11 1 -40 -10 -65 -23z"
          />
          <path
            d="M5143 1436 c-112 -28 -173 -102 -173 -207 0 -102 50 -147 217 -199
105 -32 138 -55 125 -89 -9 -25 -23 -31 -74 -31 -53 0 -139 29 -193 65 -20 14
-39 25 -43 25 -13 0 -74 -130 -68 -145 2 -7 38 -30 79 -50 193 -92 416 -63
485 65 20 38 23 55 19 108 -8 108 -48 143 -231 202 -76 25 -100 37 -108 56
-29 63 69 71 201 16 l72 -30 35 70 c43 84 41 87 -64 124 -88 30 -206 39 -279
20z"
          />
          <path
            d="M880 1095 l0 -335 100 0 100 0 0 115 0 114 148 3 147 3 3 72 3 72
-148 3 -148 3 -3 68 -3 67 161 0 160 0 0 75 0 75 -260 0 -260 0 0 -335z"
          />
          <path
            d="M1460 1095 l0 -336 88 3 87 3 5 189 5 189 24 -54 c14 -30 46 -100 73
-157 l48 -103 66 3 67 3 71 155 71 155 5 -190 5 -190 85 0 85 0 3 333 2 332
-108 0 -109 0 -86 -180 c-48 -99 -89 -180 -92 -180 -3 0 -44 81 -92 180 l-87
180 -108 0 -108 0 0 -335z"
          />
          <path
            d="M2350 1095 l0 -337 193 4 c172 4 198 7 251 27 141 56 214 176 204
335 -9 132 -68 219 -188 275 -53 25 -64 26 -257 29 l-203 4 0 -337z m368 160
c75 -45 104 -163 62 -250 -32 -66 -68 -85 -157 -85 l-73 0 0 181 0 182 70 -6
c38 -3 83 -13 98 -22z"
          />
          <path
            d="M3171 1207 c-51 -122 -113 -268 -137 -324 -24 -56 -44 -107 -44 -112
0 -7 35 -11 96 -11 l95 0 25 55 25 55 133 0 133 0 19 -52 19 -53 103 -3 c79
-2 102 0 102 10 0 8 -16 52 -36 98 -49 115 -118 283 -169 410 -66 165 -49 150
-168 150 l-102 -1 -94 -222z m236 -89 c18 -50 30 -95 27 -100 -3 -4 -36 -8
-75 -8 -81 0 -81 -1 -41 102 16 40 32 82 36 92 9 27 16 16 53 -86z"
          />
          <path
            d="M3662 1353 l3 -78 93 -3 92 -3 0 -254 0 -255 100 0 100 0 0 255 0
254 98 3 97 3 3 78 3 77 -296 0 -296 0 3 -77z"
          />
          <path
            d="M4440 1406 c-5 -14 -40 -98 -79 -188 -167 -390 -188 -443 -182 -451
5 -4 50 -6 101 -5 l93 3 17 50 17 50 138 0 138 0 20 -52 20 -53 103 0 c57 0
104 2 104 4 0 3 -59 148 -131 323 -72 175 -134 324 -136 331 -4 8 -35 12 -109
12 -102 0 -105 -1 -114 -24z m152 -286 c19 -55 33 -102 30 -105 -8 -8 -152 -6
-152 3 0 15 74 202 80 202 3 0 22 -45 42 -100z"
          />
          <path
            d="M5580 1198 c0 -223 1 -235 24 -283 30 -65 104 -131 169 -150 66 -19
170 -19 237 1 39 12 66 29 105 67 76 77 85 119 85 385 l0 212 -100 0 -100 0 0
-210 c0 -244 -6 -271 -67 -296 -47 -20 -102 -6 -132 33 -20 24 -21 39 -21 249
l0 224 -100 0 -100 0 0 -232z"
          />
          <path
            d="M6290 1095 l0 -337 223 4 c208 3 225 4 269 26 89 44 131 124 109 205
-13 46 -58 101 -91 112 -27 9 -25 19 5 33 66 30 88 153 39 212 -15 17 -45 41
-68 53 -38 20 -57 22 -263 25 l-223 4 0 -337z m368 173 c17 -17 15 -58 -5 -80
-13 -14 -31 -18 -90 -18 l-73 0 0 55 0 55 78 0 c47 0 83 -5 90 -12z m14 -255
c24 -21 23 -58 -2 -83 -17 -17 -33 -20 -100 -20 l-80 0 0 60 0 60 82 0 c62 0
86 -4 100 -17z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
